import { Badge } from "../common/Badge";
import { useFeatureTheme } from "../../context/FeatureThemeContext";

export function ThemeBadge() {
  const { theme } = useFeatureTheme();
  return (
    <span title={`Theme: ${theme}. It decides which features show in your menu (change it in Settings > Theme)`}>
      <Badge tone={theme === "Basic" ? "neutral" : "honey"}>{theme}</Badge>
    </span>
  );
}
